export default __webpack_public_path__ + "static/media/loja-android.7f9c8224.png";